import { useTranslation } from 'react-i18next';

const NotFound = () => {
  const { t } = useTranslation(['invite']);

  return <p>{t('invite:notFound.paragraph')} </p>;
};

export default NotFound;
